import React from 'react'

//  Components
import Button from '../Button/Button'

//  Styles
import styles from './AboutCallout.module.scss'

const AboutCallout = props => (
  <ul className={styles.about__callout}>
    <li>
      <h3><strong>Get additional information on indicators and ranking approach</strong></h3>
      <Button href="/methodology" text="View Scorecard Methods" />
    </li>
  </ul>
)

export default AboutCallout



// WEBPACK FOOTER //
// ./src/components/AboutCallout/AboutCallout.js